import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { Image } from '@/components/client';
interface ErrorProps {
  error: Error;
  reset: () => void;
}
export const ErrorFallback = t0 => {
  const $ = _c(9);
  const {
    error,
    reset
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Image alt="ghost" className="animate-fade-up animate-delay-300 animate-ease-in-out" height={148} src="/assets/pngs/ghost.png" width={148} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== error.message) {
    t3 = <div className="flex flex-col items-center justify-center">{t2}<p className="pt-48 text-center font-600 text-Gray-900 typo-body1">{error.message}</p></div>;
    $[2] = error.message;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== reset) {
    t4 = <footer className="w-full px-20 py-16"><Button className="w-full" onClick={reset}>다시 시도하기</Button></footer>;
    $[4] = reset;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <>{t1}{t3}{t4}</>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};